import z from "zod";

export const bordersSchema = z.object({
  borderTopColor: z
    .string()
    .optional()
    .refine((value) => !value || CSS.supports("border-top-color", value), `Invalid top outline color`),
  borderRightColor: z
    .string()
    .optional()
    .refine((value) => !value || CSS.supports("border-right-color", value), `Invalid right outline color`),
  borderBottomColor: z
    .string()
    .optional()
    .refine((value) => !value || CSS.supports("border-bottom-color", value), `Invalid bottom outline color`),
  borderLeftColor: z
    .string()
    .optional()
    .refine((value) => !value || CSS.supports("border-left-color", value), `Invalid left outline color`),
  borderColor: z
    .string()
    .optional()
    .refine((value) => !value || CSS.supports("border-color", value), `Invalid outline color`),
  borderStyle: z
    .string()
    .optional()
    .refine((value) => !value || CSS.supports("border-style", value), `Invalid outline style`),
});
